<template>
  <div
    class="group-3-subsection animate__animated animate__fadeInUp animate__delay-2s"
    :style="{ top: top + 'px' }"
  >
    <div class="rectangle-9" />

    <div class="group">
      <img class="image-2" alt="Image" :src="wechat || '/static/img/image-487@2x.png'" />
    </div>

    <div class="image-wrapper">
      <img class="image-2" alt="Image" :src="redbook || '/static/img/image-487-1@2x.png'" />
    </div>

    <div class="group-2">
      <div class="text-wrapper-16">电话： {{ tel }}</div>

      <div class="text-wrapper-17">邮箱：{{ email }}</div>

      <div class="group-3">
        <div class="text-wrapper-18">邮编：{{ code }}</div>

        <div class="text-wrapper-19">地址：{{ address }}</div>
      </div>
    </div>

    <div class="div-wrapper">
      <div class="text-wrapper-20">联系我们</div>
    </div>

    <div class="group-4">
      <a
        class="text-wrapper-21"
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ icp }}
      </a>
      <a
        class="beian-link"
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >
        工信部备案管理系统：https://beian.miit.gov.cn
      </a>
    </div>

    <div class="separator" aria-hidden="true"></div>

    <div class="text-wrapper-22">微信</div>

    <div class="text-wrapper-23">小红书</div>
  </div>
</template>

<script>
import { getBottom } from "../../../directus/api.js";
export default {
  name: "Group3Subsection",
  props: { top: { type: Number, default: 2200 } },
  data() {
    return { tel: "17631142036", email: "yfzp@yfpy.top", code: "050000", address: "河北省石家庄市裕华区富强大街19号聚星城2层010号", icp: "冀ICP备2025112385号-1", wechat: null, redbook: null };
  },
  mounted() {
    getBottom().then((b) => {
      if (b) {
        this.tel = b.tel || this.tel;
        this.email = b.email || this.email;
        this.code = b.code || this.code;
        this.address = b.address || this.address;
        this.icp = (b.icp && b.icp.includes("2025112385号-1")) ? b.icp : this.icp;
        this.wechat = b.wechat || this.wechat;
        this.redbook = b.redbook || this.redbook;
      }
    }).catch(() => {});
  },
};
</script>


<style scoped>
.group-3-subsection {
  height: 233px;
  left: 0;
  position: absolute;
  width: 100%;
}

.group-3-subsection .rectangle-9 {
  background-color: #07183a;
  height: 233px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.group-3-subsection .group {
  background-color: #ffffff;
  display: flex;
  height: 80px;
  left: 1579px;
  position: absolute;
  top: 39px;
  width: 80px;
}

.group-3-subsection .image-2 {
  height: 72px;
  margin-left: 4px;
  margin-top: 4px;
  object-fit: cover;
  width: 72px;
}

.group-3-subsection .image-wrapper {
  background-color: #ffffff;
  display: flex;
  height: 80px;
  left: 1677px;
  position: absolute;
  top: 39px;
  width: 80px;
}

.group-3-subsection .group-2 {
  height: 24.89%;
  left: 17.31%;
  position: absolute;
  top: 24.03%;
  width: 36.49%;
}

.group-3-subsection .text-wrapper-16 {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 27.59%;
  left: 0;
  letter-spacing: 0;
  line-height: 16px;
  opacity: 0.8;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 21.23%;
}

.group-3-subsection .text-wrapper-17 {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 27.59%;
  left: 0;
  letter-spacing: 0;
  line-height: 16px;
  opacity: 0.8;
  position: absolute;
  top: 63.79%;
  white-space: nowrap;
  width: 21.79%;
}

.group-3-subsection .group-3 {
  height: 100%;
  left: 39.60%;
  position: absolute;
  top: 0;
  width: 60.40%;
}

.group-3-subsection .text-wrapper-18 {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 27.59%;
  left: 0;
  letter-spacing: 0;
  line-height: 16px;
  opacity: 0.8;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 25.00%;
}

.group-3-subsection .text-wrapper-19 {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 37.93%;
  left: 0;
  letter-spacing: 0;
  line-height: 22px;
  opacity: 0.8;
  position: absolute;
  top: 62.07%;
  white-space: nowrap;
  width: 99.06%;
}

.group-3-subsection .div-wrapper {
  display: flex;
  height: 12.02%;
  left: 8.32%;
  position: absolute;
  top: 24.46%;
  width: 6.76%;
}

.group-3-subsection .text-wrapper-20 {
  align-items: center;
  color: #ffffff;
  display: flex;
  flex: 1;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 32px;
  font-weight: 400;
  justify-content: center;
  letter-spacing: 0;
  line-height: 48px;
  white-space: nowrap;
  width: 128px;
}

.group-3-subsection .group-4 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: auto;
  left: 50%;
  position: absolute;
  top: 166px;
  transform: translateX(-50%);
  width: auto;
}

.group-3-subsection .text-wrapper-21 {
  color: #ffffffcc;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.28px;
  line-height: 14px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}

.group-3-subsection .text-wrapper-21:hover,
.group-3-subsection .beian-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.group-3-subsection .beian-link {
  color: #ffffff99;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}

.group-3-subsection .separator {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 328px;
  top: 158px;
  height: 1px;
  background: linear-gradient(90deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.2) 100%);
}

.group-3-subsection .text-wrapper-22 {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 1582px;
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  top: 127px;
  white-space: nowrap;
}

.group-3-subsection .text-wrapper-23 {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 1676px;
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  top: 127px;
  white-space: nowrap;
}
</style>
